import { ChatOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';
import { PageHeaderStatic, WidgetIcon } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { I18nNamespace } from '~/common/types';
import { RouteId } from '~/routes/RouteId';

export const IntakeChatHeader = () => {
  const navigate = useNavigate();

  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'Chat' });

  return (
    <PageHeaderStatic
      title={t('title')}
      maxWidth={false}
      sx={{ minHeight: 64 }}
      icon={<WidgetIcon color="primary" icon={<ChatOutlined fontSize="small" />} />}
      right={
        <Button variant="outlined" startIcon={<ChatOutlined />} onClick={() => navigate(RouteId.intakeCreate)}>
          {t('newRequest')}
        </Button>
      }
    />
  );
};
